import {
  redirect,
  Route,
  Routes,
  useNavigate,
  useResolvedPath,
} from "react-router";
import NavBar from "./components/shared/NavBar/NavBar";
import { BiletPage } from "./pages/Bilet";

import {
  BiletGrid,
  QuestionGrid,
  ThemeGrid,
} from "./components/DataGrid/inedex";

import "moment/locale/ru";
import moment from "moment";

import { useStore } from "./hooks/store";
import LoginPage from "./pages/Login/Login";
import { useEffect, useState } from "react";
import { getToken, setToken } from "./utils/API/authMethods";

import PddGrid from "./components/DataGrid/PddGrid";
import MDEditor from "./components/MDEditor";
import Pdd from "./pages/Pdd/Pdd";
import Video from "./pages/Video/Video";
import News from "./pages/News/News";
import NewsGrid from "./components/DataGrid/NewsGrid";
import NewsThemeGrid from "./components/DataGrid/NewsThemeGrid";
import User from "./pages/User/User";
import School from "./pages/School/School";
import UserGrid from "./components/DataGrid/UserGrid";
import UserRedactPage from "./pages/User/UserRedactPage";
import { SchoolGrid } from "./components/DataGrid/SchoolGrid";
import SchoolRedactPage from "./pages/School/SchoolRedactPage";
import axios from "axios";
import OrderPage from "./pages/School/Order";
import { PddThemeGrid } from "./components/DataGrid/PddThemeGrid";
import SessionGrid from "./components/DataGrid/SessionGrid";
import Session from "./pages/Session/Session";

const PathTemplate = () => {
  return (
    <main>
      <h1>Template</h1>
    </main>
  );
};

moment().locale("ru");
function App() {
  const store = useStore();
  const nav = useNavigate();

  const [loading, setLoading] = useState(true);

  const path = useResolvedPath();

  useEffect(() => {
    setLoading(true);

    const token = getToken();

    if (!token) {
      nav("/login");
    }
    setToken(token);
    if (path.pathname === "/") {
      nav("/bilet");
    }
    setLoading(false);
  }, []);

  return (
    <>
      <NavBar />
      <Routes>
        {!loading && (
          <>
            <Route path="*" element={<PathTemplate />} />

            <Route path="login" element={<LoginPage />} />

            <Route path="bilet" element={<BiletPage />}>
              <Route index element={<BiletGrid />} />
              <Route path="question" element={<QuestionGrid />} />
              <Route path="theme" element={<ThemeGrid />} />
            </Route>

            <Route path="pdd" element={<Pdd />}>
              <Route index element={<PddGrid />} />
              <Route path="pdd_theme" element={<PddThemeGrid />} />
              <Route path="editor" element={<MDEditor />} />
            </Route>

            <Route path="video" element={<Session />} />

            <Route path="news" element={<News />}>
              <Route index element={<NewsGrid />} />
              <Route path="category" element={<NewsThemeGrid />} />
            </Route>

            <Route path="sessions" element={<Session />} />

            <Route path="user" element={<User />}>
              <Route index element={<UserGrid />} />
              <Route path={":userId"} element={<UserRedactPage />} />
            </Route>

            <Route path="school" element={<School />}>
              <Route index element={<SchoolGrid />} />
              <Route path=":schoolId" element={<SchoolRedactPage />} />
            </Route>

            <Route path="order/:orderId" element={<OrderPage />} />
          </>
        )}
      </Routes>
    </>
  );
}

export default App;
